import React from 'react';
import './InputFormsForQuizes.scss';
import { closeInputForms, idQuestionsDelete } from '../../../adminSlice';

export default class DeleteInputFormsForQuestions  extends React.Component {
    constructor(props) {
        super(props);
        
       
       this.onSend = this.onSend.bind(this);
       this.onClose = this.onClose.bind(this);
    }

  
 // CLICK OK
onSend() {
        const { dispatch } = this.props;

        const item = {
            question_id: this.props.adminState.selectedId,
           // main_name: this.state.userInputContent,
            
        }
        console.log(item);
        dispatch(idQuestionsDelete(item));  
}


// CLOSE FORM
onClose() {
    const { dispatch } = this.props;
    dispatch(closeInputForms());

}

   renderTable() {
   // let  data =  this.props.data;
    return null;
   }
   
    render() {
        //console.log(this.props.adminState.openInputForms);
     if (this.props.adminState.openDeleteInputFormsForQuestions) {
        return(
            <div className="InputFormsForQuizes">
                <p className='p-text'>id: {this.props.adminState.selectedId}</p>
                <p className='p-text'>Вопрос:{this.props.adminState.dataQuestionsId.map(item => {
              // console.log(item)
                if (item.id === Number(this.props.adminState.selectedId))
               //console.log(item.label)
                {return item.text;} else return null;
                })}
                </p>
                


             <p>Вы действительно хотите удалить данный вопрос?</p>
             <p className='p-text'>(Удалить возможно только <strong> пустой </strong> вопрос)</p>
             <button onClick={this.onSend}>Да</button>
             <button onClick={this.onClose}>Отмена</button>
            </div>
        )
     } else return null;
       
     

        
    }
}